import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonthlyCardComponent } from './components/monthly-card/monthly-card.component';
import { HowItWorksModule } from '../how-it-works/how-it-works.module';
import { SharedModule } from '../../shared/shared.module';
import { CloseBtnModule } from '../close-btn/close-btn.module';
import { SupportersComponent } from './components/supporters/supporters.component';
import { BeneficiaryListModule } from '../beneficiary-list/beneficiary-list.module';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  imports: [
    CommonModule,
    HowItWorksModule,
    SharedModule,
    CloseBtnModule,
    BeneficiaryListModule,
    MatButtonModule
  ],
  declarations: [MonthlyCardComponent, SupportersComponent],
  exports: [MonthlyCardComponent, SupportersComponent],
})
export class MonthlyCardModule { }
